/* eslint-disable react/no-unescaped-entities */
import React from 'react';
// import { LazyLoadImage } from 'react-lazy-load-image-component';
// import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
// import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';

const mock = [
  {
    description:
      'Class Assembly 12A',
    href : '/class-assembly-12-a-2026'
  },
  {
    description:
      'Class Assembly 12B',
    href : '/class-assembly-12-b-2026'
  },
  {
    description:
      'Class Assembly 12C',
    href : '/class-assembly-12-c-2026'
  },
   {
    description:
      'Class Assembly 11A',
    href : '/class-assembly-11-a-2026'
  },
  {
    description:
      'Class Assembly 11B',
    href : '/class-assembly-11-b-2026'
  },
  {
    description:
      'Class Assembly 11C',
    href : '/class-assembly-11-c-2026'
  },
  {
    description:
      'Class Assembly 10A',
    href : '/class-assembly-10a-2026'
  },
  {
    description:
      'Class Assembly 10B',
    href : '/class-assembly-10-b-2026'
  },
  {
    description:
      'Class Assembly 10C',
    href : '/class-assembly-10-C-2026'
  },
  {
    description:
      'Class Assembly 10D',
    href : '/class-assembly-10-d-2026'
  },
  {
    description:
      'Class Assembly 10E',
    href : '/class-assembly-10-E-2026'
  },
   {
    description:
      'Class Assembly 9A',
    href : '/class-assembly-9-a-2026'
  },
  {
    description:
      'Class Assembly 9B',
    href : '/class-assembly-9-b-2026'
  },
  {
    description:
      'Class Assembly 9C',
    href : '/class-assembly-9-c-2026'
  },
   {
    description:
      'Class Assembly 9D',
    href : '/class-assembly-9-d-2026'
  },
   {
    description:
      'Class Assembly 9E',
    href : '/class-assembly-9-e-2026'
  },
  {
    description:
      'Class Assembly 8A',
    href : '/class-assembly-8-a-2026'
  },
  {
    description:
      'Class Assembly 8B',
    href : '/class-assembly-8-b-2026'
  },
   {
    description:
      'Class Assembly 8C',
    href : '/class-assembly-8-c-2026'
  },
  {
    description:
      'Class Assembly 8D',
    href : '/class-assembly-8-d-2026'
  },
  {
    description:
      'Class Assembly 8E',
    href : '/class-assembly-8-e-2026'
  },
  {
    description:
      'Class Assembly 8F',
    href : '/class-assembly-8-f-2026'
  },
  {
    description:
      'Class Assembly 7A',
    href : '/class-assembly-7-a-2026'
  },
  {
    description:
      'Class Assembly 7B',
    href : '/class-assembly-7-b-2026'
  },
   {
    description:
      'Class Assembly 7C',
    href : '/class-assembly-7-c-2026'
  },
   {
    description:
      'Class Assembly 5A',
    href : '/class-assembly-5-a-2026'
  },
  {
    description:
      'Class Assembly 5B',
    href : '/class-assembly-5-b-2026'
  },
   {
    description:
      'Class Assembly 5C',
    href : '/class-assembly-5-c-2026'
  },
   {
    description:
      'Class Assembly 5D',
    href : '/class-assembly-5-d-2026'
  },
  {
    description:
      'Class Assembly 5E',
    href : '/class-assembly-5-e-2026'
  },
  {
    description:
      'Class Assembly 4A',
    href : '/class-assembly-4-a-2026'
  },
    {
    description:
      'Class Assembly 4B',
    href : '/class-assembly-4-b-2026'
  },
{
    description:
      'Class Assembly 4C',
    href : '/class-assembly-4-c-2026'
  },
  {
    description:
      'Class Assembly 4D',
    href : '/class-assembly-4-d-2026'
  },
   {
    description:
      'Class Assembly 4E',
    href : '/class-assembly-4-e-2026'
  },
 {
    description:
      'Class Assembly 3A',
    href : '/class-assembly-3-a-2026'
  },
   {
    description:
      'Class Assembly 3B',
    href : '/class-assembly-3-b-2026'
  },
   {
    description:
      'Class Assembly 3C',
    href : '/class-assembly-3-c-2026'
  },
   {
    description:
      'Class Assembly 3D',
    href : '/class-assembly-3-d-2026'
  },


];

const ClassAssemblySidebar2026 = () => {
  
  return (
    <Box component={Card} variant={'outlined'} padding={2}>
      <Typography
        variant="h6"
        data-aos={'fade-up'}
        sx={{
          fontWeight: 700,
          marginBottom: 2,
        }}
      >
        Class Assembly 2026-27
      </Typography>
      <Grid container spacing={2}>
        {mock.map((item, i) => (
          <Grid key={i} item xs={12}>
            <Box
              component={Card}
              width={1}
              height={1}
              boxShadow={0}
              borderRadius={0}
              display={'flex'}
              flexDirection={{ xs: 'column', md: 'row' }}
              sx={{ backgroundImage: 'none', bgcolor: 'transparent' }}
            >
              <Button href = {item.href}>
                <Typography component={'P'}>
                  {item.description}
                </Typography>
              </Button>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default ClassAssemblySidebar2026;
